import axios from "axios";

const API_BASE_URL = "https://api2.magicqr.in";

// super_admin and role_id are fixed per the MagicQR sign-up contract - every
// signup from this site is provisioned as the same account type.
export async function signUp({ firstName, lastName, phone, email, password, passwordConfirmation }) {
  const { data } = await axios.post(`${API_BASE_URL}/auth/sign-up`, {
    first_name: firstName,
    last_name: lastName || "",
    phone,
    email,
    password,
    password_confirmation: passwordConfirmation,
    super_admin: 4,
    role_id: 4,
  });
  return data;
}

// super_admin_id is fixed per the MagicQR sign-in contract.
export async function signIn({ emailOrPhone, password }) {
  const { data } = await axios.post(`${API_BASE_URL}/auth/sign-in`, {
    email_or_phone: emailOrPhone,
    password,
    super_admin_id: 4,
  });
  return data;
}

export function normalizePhone(raw) {
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 10) return `91${digits}`;
  return digits;
}

export function extractApiErrorMessage(error) {
  const data = error?.response?.data;
  if (!data) return "Something went wrong. Please try again.";
  if (data.message) return data.message;
  if (data.errors) {
    const firstField = Object.values(data.errors)[0];
    if (Array.isArray(firstField)) return firstField[0];
  }
  return "Something went wrong. Please try again.";
}
